module.exports = __webpack_public_path__ + "img/KinokoTable28.6aa7066c.jpg";